import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  bodyBold2czwdzwknab0k as bodyBold,
  title1nssp3ryhwuqj as title,
  titleWithClose1c8wgipb8qrii as titleWithClose,
  body3i5t0n7zprpqb as body,
} from '../theming/Titles.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../theming/colorManagement.mjs';
import {
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  Companion_getInstance1350ksylxva5s as Companion_getInstance,
  Set2awzlbbrsme5i as Set,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  plus310ted5e4i90h as plus,
  first58ocm7j58k3q as first,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_appThemejy2o9bdilpry as get_appTheme } from '../theming/appTheme.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { resolveProjectAttachments1r3ylk2p3xmwv as resolveProjectAttachments } from '../components/files/attachmentFilePreview.mjs';
import {
  ContractorNote59o6kpmrrw5h as ContractorNote,
  PunchListItem1wbu5dz9rlo4k as PunchListItem,
} from '../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { label287uhiq3m9m4z as label2 } from '../components/label2.mjs';
import { fileManager1pvd5zvbyt8nt as fileManager } from '../components/files/fileManager.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { assertNotBlank1cpq7aqdam42n as assertNotBlank } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function selectLineItem(_this__u8e3s4, edits, options) {
  // Inline function 'com.crowpay.views.components.requiredField' call
  var label = 'Line Item';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  view.bb9(get_AppDimensions().pg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(false);
  view_0.bb9(get_AppDimensions().rg2_1);
  view_0.lbb(get_centered(view_0), bodyBold(view_0, label));
  view_0.lbb(colored(view_0, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_0, '*'));
  view.hbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = view.jbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.select' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Select())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  var tmp_0 = _Constant___init__impl__v45mub(plus(listOf(null), options));
  view_1.ocf(edits, new (Constant())(tmp_0), selectLineItem$lambda);
  view.hbb(p_1, view_1);
  view.lbb(tmp, view_1);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function dialogFrame(_this__u8e3s4, content) {
  // Inline function 'com.crowpay.views.components.dismissBackground2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (DismissBackground())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.vbo(dialogFrame$slambda_0());
  view.gba(get_AppDimensions().yg1_1);
  var tmp = view.kbb(view.jbb(DialogSemantic_getInstance()), get_centered(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.gba(get_AppDimensions().yg1_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(true);
  Companion_getInstance();
  // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
  var theme = get_appTheme();
  var tmp$ret$0 = new (Set())(theme);
  view_1.lba(tmp$ret$0);
  content(view_1);
  view_0.hbb(p_1, view_1);
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  return LiveApi2$Api2LineItemLive$uploadFileForRequest$ref_0(tmp$ret$0.vfw().gfg_1);
}
var LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass;
function LiveApi2$Api2LineItemLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.fid_1 = p0;
      }
      uao($completion) {
        return this.fid_1.lfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2LineItemLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2LineItemLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.uao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.kid_1.jid_1;
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var item = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.kid_1.hid_1;
  var tmp_1 = await_1(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var m = tmp_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.kid_1.iid_1;
  var tmp_2 = await_1(this_2, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp$ret$2 = tmp_2;
  var tmp_3 = resolveProjectAttachments(tmp$ret$2, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var f = tmp_3;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = get_session();
  var tmp_4 = await_0(this_3, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp_5 = tmp_4.bfw_1;
  var tmp1_lineItem = item.mf9_1;
  var tmp2_project = item.jf9_1.f6k_1;
  var tmp_6 = tmp_5.oft(new (ContractorNote())(VOID, tmp2_project, tmp1_lineItem, m, f), $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  get_dialogStack().pgd();
  return Unit_instance;
}
var RootCreateItemNote$render$lambda$lambda$slambdaClass;
function RootCreateItemNote$render$lambda$lambda$slambda() {
  if (RootCreateItemNote$render$lambda$lambda$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    RootCreateItemNote$render$lambda$lambda$slambdaClass = $;
  }
  return RootCreateItemNote$render$lambda$lambda$slambdaClass;
}
function RootCreateItemNote$render$lambda$lambda$slambda_0() {
  var i = new (RootCreateItemNote$render$lambda$lambda$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var RootCreateItemNote$render$lambda$slambdaClass;
function RootCreateItemNote$render$lambda$slambda() {
  if (RootCreateItemNote$render$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.kid_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    RootCreateItemNote$render$lambda$slambdaClass = $;
  }
  return RootCreateItemNote$render$lambda$slambdaClass;
}
function RootCreateItemNote$render$lambda$slambda_0(this$0) {
  var i = new (RootCreateItemNote$render$lambda$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var RootCreateItemNote$render$lambda$slambdaClass_0;
function RootCreateItemNote$render$lambda$slambda_1() {
  if (RootCreateItemNote$render$lambda$slambdaClass_0 === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    RootCreateItemNote$render$lambda$slambdaClass_0 = $;
  }
  return RootCreateItemNote$render$lambda$slambdaClass_0;
}
function RootCreateItemNote$render$lambda$slambda_2() {
  var i = new (RootCreateItemNote$render$lambda$slambda_1())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var RootCreateItemNoteClass;
function RootCreateItemNote() {
  if (RootCreateItemNoteClass === VOID) {
    class $ {
      constructor(lineItems) {
        this.gid_1 = lineItems;
        this.hid_1 = Signal().hak('');
        this.iid_1 = Signal().hak(emptyList());
        this.jid_1 = Signal().hak(null);
      }
      wd6(_this__u8e3s4) {
        return dialogFrame(_this__u8e3s4, ($this$dialogFrame) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$dialogFrame.pc());
          var tmp0_elvis_lhs = $this$dialogFrame.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$dialogFrame : tmp0_elvis_lhs;
          $this$dialogFrame.gbb(p, view);
          view.zbm(true);
          title(view, 'New Note');
          selectLineItem(view, this.jid_1, this.gid_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.zbm(true);
          label2(view_0, 'Message', VOID, ($this$label2) => {
            var tmp0_width = get_rem(40);
            var tmp1_minHeight = get_rem(10);
            var tmp = sizeConstraints($this$label2, VOID, VOID, tmp1_minHeight, VOID, VOID, tmp0_width);
            // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
            var tmp$ret$0 = $this$label2.jbb(FieldSemantic_getInstance());
            var tmp_0 = $this$label2.kbb(tmp, tmp$ret$0);
            // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (TextArea())($this$label2.pc());
            var tmp0_elvis_lhs = $this$label2.ebb_1;
            var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
            $this$label2.gbb(p, view);
            view.zah(view.scl_1, this.hid_1);
            $this$label2.hbb(p, view);
            return $this$label2.lbb(tmp_0, view);
          });
          label2(view_0, 'Files', VOID, ($this$label2) => {
            var tmp = sizeConstraints($this$label2, VOID, VOID, VOID, VOID, VOID, get_rem(40));
            // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
            var tmp$ret$4 = $this$label2.jbb(FieldSemantic_getInstance());
            var tmp_0 = $this$label2.kbb(tmp, tmp$ret$4);
            return $this$label2.lbb(tmp_0, fileManager($this$label2, this.iid_1, 'No Files Uploaded', VOID, VOID, RootCreateItemNote$render$lambda$lambda$slambda_0()));
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_1 = view_0.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.gbb(p_1, view_1);
          view_1.zbm(false);
          view_1.bb9(get_AppDimensions().kg2_1);
          var tmp = get_primaryButton(view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (Button())(view_1.pc());
          var tmp0_elvis_lhs_2 = view_1.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
          view_1.gbb(p_2, view_2);
          var tmp_0 = KMutableProperty0();
          var tmp_1 = Button$_get_enabled_$ref_61t7nx(view_2);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, Button$_set_enabled_$ref_o8kynz(view_2));
          reactiveScope(view_2, ($this$reactiveScope) => {
            var tmp;
            if (!($this$reactiveScope.daj(this.jid_1) == null)) {
              var tmp_0;
              // Inline function 'kotlin.text.isNotBlank' call
              var this_1 = $this$reactiveScope.daj(this.hid_1);
              if (!isBlank(this_1)) {
                tmp_0 = true;
              } else {
                // Inline function 'kotlin.collections.isNotEmpty' call
                tmp_0 = !$this$reactiveScope.daj(this.iid_1).i1();
              }
              tmp = tmp_0;
            } else {
              tmp = false;
            }
            var tmp$ret$7 = tmp;
            this_0.set(tmp$ret$7);
            return Unit_instance;
          });
          specCenteredText(view_2, 'Create Note');
          onClick(view_2, VOID, VOID, RootCreateItemNote$render$lambda$slambda_0(this));
          view_1.hbb(p_2, view_2);
          view_1.lbb(tmp, view_2);
          var tmp_2 = get_textButton(view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (Button())(view_1.pc());
          var tmp0_elvis_lhs_3 = view_1.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
          view_1.gbb(p_3, view_3);
          specCenteredText(view_3, 'Go Back');
          onClick(view_3, VOID, VOID, RootCreateItemNote$render$lambda$slambda_2());
          view_1.hbb(p_3, view_3);
          view_1.lbb(tmp_2, view_3);
          view_0.hbb(p_1, view_1);
          view.hbb(p_0, view_0);
          $this$dialogFrame.hbb(p, view);
          return view;
        });
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'RootCreateItemNote', VOID, VOID, [Page()]);
    RootCreateItemNoteClass = $;
  }
  return RootCreateItemNoteClass;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.pid_1.oid_1;
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.let' call
  var it = tmp;
  var tmp4_lineItem = it == null ? null : it.mf9_1;
  var tmp2_safe_receiver = it == null ? null : it.jf9_1;
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.f6k_1;
  var tmp5_project = tmp3_elvis_lhs == null ? first($this.pid_1.lid_1).lfy() : tmp3_elvis_lhs;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.pid_1.mid_1;
  var tmp_0 = await_1(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp6_content = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.pid_1.nid_1;
  var tmp_1 = await_1(this_2, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp7_required = tmp_1;
  var punchItem = new (PunchListItem())(VOID, tmp5_project, tmp4_lineItem, VOID, VOID, tmp6_content, tmp7_required);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = get_session();
  var tmp_2 = await_0(this_3, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = tmp_2.tfv_1.oft(punchItem, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  get_dialogStack().pgd();
  return Unit_instance;
}
function RootCreateItemTask$render$lambda$lambda() {
  get_dialogStack().wgg();
  return Unit_instance;
}
function RootCreateItemTask$render$lambda$lambda_0(it) {
  var tmp1_elvis_lhs = it == null ? null : it.nf9_1;
  return tmp1_elvis_lhs == null ? 'Punch Tasks' : tmp1_elvis_lhs;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var RootCreateItemTask$render$lambda$slambdaClass;
function RootCreateItemTask$render$lambda$slambda() {
  if (RootCreateItemTask$render$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.pid_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    RootCreateItemTask$render$lambda$slambdaClass = $;
  }
  return RootCreateItemTask$render$lambda$slambdaClass;
}
function RootCreateItemTask$render$lambda$slambda_0(this$0) {
  var i = new (RootCreateItemTask$render$lambda$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var RootCreateItemTask$render$lambda$slambdaClass_0;
function RootCreateItemTask$render$lambda$slambda_1() {
  if (RootCreateItemTask$render$lambda$slambdaClass_0 === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().wgg();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    RootCreateItemTask$render$lambda$slambdaClass_0 = $;
  }
  return RootCreateItemTask$render$lambda$slambdaClass_0;
}
function RootCreateItemTask$render$lambda$slambda_2() {
  var i = new (RootCreateItemTask$render$lambda$slambda_1())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var RootCreateItemTaskClass;
function RootCreateItemTask() {
  if (RootCreateItemTaskClass === VOID) {
    class $ {
      constructor(lineItems) {
        this.lid_1 = lineItems;
        this.mid_1 = assertNotBlank(Signal().hak(''));
        this.nid_1 = Signal().hak(false);
        this.oid_1 = Signal().hak(null);
      }
      wd6(_this__u8e3s4) {
        return dialogFrame(_this__u8e3s4, ($this$dialogFrame) => {
          var tmp = sizeConstraints($this$dialogFrame, VOID, VOID, VOID, VOID, VOID, get_rem(30));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$dialogFrame.pc());
          var tmp0_elvis_lhs = $this$dialogFrame.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$dialogFrame : tmp0_elvis_lhs;
          $this$dialogFrame.gbb(p, view);
          view.zbm(true);
          view.bb9(get_AppDimensions().zg1_1);
          titleWithClose(view, 'New Task', RootCreateItemTask$render$lambda$lambda);
          // Inline function 'com.crowpay.views.components.requiredField' call
          var label = 'Destination';
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.zbm(true);
          view_0.bb9(get_AppDimensions().pg2_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_1 = view_0.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.gbb(p_1, view_1);
          view_1.zbm(false);
          view_1.bb9(get_AppDimensions().rg2_1);
          view_1.lbb(get_centered(view_1), bodyBold(view_1, label));
          view_1.lbb(colored(view_1, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_1, '*'));
          view_0.hbb(p_1, view_1);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp_0 = view_0.jbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (Select())(view_0.pc());
          var tmp0_elvis_lhs_2 = view_0.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
          view_0.gbb(p_2, view_2);
          var tmp_1 = _Constant___init__impl__v45mub(plus(listOf(null), this.lid_1));
          view_2.ocf(this.oid_1, new (Constant())(tmp_1), RootCreateItemTask$render$lambda$lambda_0);
          view_0.hbb(p_2, view_2);
          view_0.lbb(tmp_0, view_2);
          view.hbb(p_0, view_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_3 = view.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
          view.gbb(p_3, view_3);
          view_3.zbm(true);
          view_3.bb9(get_rem(1));
          // Inline function 'com.crowpay.views.components.requiredField' call
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (RowOrCol())(view_3.pc());
          var tmp0_elvis_lhs_4 = view_3.ebb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
          view_3.gbb(p_4, view_4);
          view_4.zbm(true);
          view_4.bb9(get_AppDimensions().pg2_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (RowOrCol())(view_4.pc());
          var tmp0_elvis_lhs_5 = view_4.ebb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
          view_4.gbb(p_5, view_5);
          view_5.zbm(false);
          view_5.bb9(get_AppDimensions().rg2_1);
          view_5.lbb(get_centered(view_5), bodyBold(view_5, 'Name'));
          view_5.lbb(colored(view_5, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_5, '*'));
          view_4.hbb(p_5, view_5);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp_2 = view_4.jbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_6 = new (TextInput())(view_4.pc());
          var tmp0_elvis_lhs_6 = view_4.ebb_1;
          var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
          view_4.gbb(p_6, view_6);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view_6.vb5_1.bb4_1.kb7_1.placeholder = 'Name';
          view_6.zah(view_6.icn_1, this.mid_1);
          view_4.hbb(p_6, view_6);
          view_4.lbb(tmp_2, view_6);
          view_3.hbb(p_4, view_4);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_7 = new (RowOrCol())(view_3.pc());
          var tmp0_elvis_lhs_7 = view_3.ebb_1;
          var p_7 = tmp0_elvis_lhs_7 == null ? view_3 : tmp0_elvis_lhs_7;
          view_3.gbb(p_7, view_7);
          view_7.zbm(false);
          var tmp_3 = get_centered(view_7);
          // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_8 = new (Checkbox())(view_7.pc());
          var tmp0_elvis_lhs_8 = view_7.ebb_1;
          var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
          view_7.gbb(p_8, view_8);
          view_8.zah(view_8.ebk_1, this.nid_1);
          view_7.hbb(p_8, view_8);
          view_7.lbb(tmp_3, view_8);
          view_7.lbb(get_centered(view_7), body(view_7, 'Required'));
          view_3.hbb(p_7, view_7);
          view.hbb(p_3, view_3);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_9 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_9 = view.ebb_1;
          var p_9 = tmp0_elvis_lhs_9 == null ? view : tmp0_elvis_lhs_9;
          view.gbb(p_9, view_9);
          view_9.zbm(false);
          view_9.bb9(get_AppDimensions().kg2_1);
          var tmp_4 = get_primaryButton(view_9);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_10 = new (Button())(view_9.pc());
          var tmp0_elvis_lhs_10 = view_9.ebb_1;
          var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
          view_9.gbb(p_10, view_10);
          var tmp_5 = KMutableProperty0();
          var tmp_6 = Button$_get_enabled_$ref_61t7nx_0(view_10);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('enabled', 0, tmp_5, tmp_6, Button$_set_enabled_$ref_o8kynz_0(view_10));
          reactiveScope(view_10, ($this$reactiveScope) => {
            var tmp$ret$41 = $this$reactiveScope.daj(get_issues(this.mid_1)).i1();
            this_0.set(tmp$ret$41);
            return Unit_instance;
          });
          specCenteredText(view_10, 'Save Task');
          onClick(view_10, VOID, VOID, RootCreateItemTask$render$lambda$slambda_0(this));
          view_9.hbb(p_10, view_10);
          view_9.lbb(tmp_4, view_10);
          var tmp_7 = get_textButton(view_9);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_11 = new (Button())(view_9.pc());
          var tmp0_elvis_lhs_11 = view_9.ebb_1;
          var p_11 = tmp0_elvis_lhs_11 == null ? view_9 : tmp0_elvis_lhs_11;
          view_9.gbb(p_11, view_11);
          specCenteredText(view_11, 'Go Back');
          onClick(view_11, VOID, VOID, RootCreateItemTask$render$lambda$slambda_2());
          view_9.hbb(p_11, view_11);
          view_9.lbb(tmp_7, view_11);
          view.hbb(p_9, view_9);
          $this$dialogFrame.hbb(p, view);
          return $this$dialogFrame.lbb(tmp, view);
        });
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'RootCreateItemTask', VOID, VOID, [Page()]);
    RootCreateItemTaskClass = $;
  }
  return RootCreateItemTaskClass;
}
function selectLineItem$lambda(it) {
  var tmp1_elvis_lhs = it == null ? null : it.nf9_1;
  return tmp1_elvis_lhs == null ? 'Select a line item' : tmp1_elvis_lhs;
}
var dialogFrame$slambdaClass;
function dialogFrame$slambda() {
  if (dialogFrame$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    dialogFrame$slambdaClass = $;
  }
  return dialogFrame$slambdaClass;
}
function dialogFrame$slambda_0() {
  var i = new (dialogFrame$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  RootCreateItemNote as RootCreateItemNote3hjykvgwuyehp,
  RootCreateItemTask as RootCreateItemTask3hcc6ixs4t028,
};
//endregion

//# sourceMappingURL=LineItemDialogs.mjs.map
